import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerWithText from '../../../../../../components/DividerWithText';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import {
    CONFLICT_RESOLUTION_LIST,
    CONFLICT_RESOLUTION_MODEL,
    STACK_METHOD_LIST
} from '../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Overtime policies configuration: edits how overtime policies resolve
 * conflicts (conflictResolution) and, when stackable, how they stack (stackMethod).
 *
 * @param item Overtime policy config model.
 * @param onChange Change handler.
 * @param emptyFields Flag to highlight required empty fields.
 */
const OvertimePolicyConfig = (
    {
        item,
        onChange,
        emptyFields,
        disabled = false
    }
) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='col-12'>
                <DividerWithText spacing='my-4' title={t('payroll_policy_configuration')} />
            </div>

            <div className="row px-0">
                <div className="col-12 col-sm-3 pb-4 pb-sm-0 fs-12px font-color-shades-950 ibl-font-w-400">
                    {t("payroll_policy_configuration_description")}
                </div>
                <div className="col-12 col-sm-9">
                    <div className="row">
                        <div className='col-12 col-sm-6 pl-0'>
                            <CustomSelect
                                id='slt_opc_conflict_resolution'
                                name='conflictResolution'
                                trans='conflict_resolution'
                                keyName='id'
                                list={CONFLICT_RESOLUTION_LIST()}
                                value={item.conflictResolution}
                                onChange={onChange}
                                required={true}
                                emptyFields={emptyFields}
                                showNoSelectionOption={false}
                                disabled={disabled}
                            />
                        </div>

                        {item.conflictResolution === CONFLICT_RESOLUTION_MODEL.STACKABLE &&
                            <div className='col-12 col-sm-6 pl-0 pl-sm-3'>
                                <CustomSelect
                                    id='slt_opc_stack_method'
                                    name='stackMethod'
                                    trans='stack_method'
                                    keyName='id'
                                    list={STACK_METHOD_LIST()}
                                    value={item.stackMethod}
                                    onChange={onChange}
                                    required={true}
                                    emptyFields={emptyFields}
                                    showNoSelectionOption={false}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default OvertimePolicyConfig;
